module.exports = __webpack_public_path__ + "static/media/item_1_7_comp.893be267.png";